import { formatParagraph } from "../../../utils/post-utils";

function Paragraph(props: Props) {
  return (
    <div className={'paragraph'} dangerouslySetInnerHTML={{ __html: formatParagraph(props.data) }} />
  )
}

export default Paragraph;

class Props {
  data: string;
}
